import React, { forwardRef } from 'react';
import { List, Spin, Space } from 'antd';
import moment from 'moment';
import { Document } from "../../types";
import router from "../../router";
import StatusBadge from '../common/StatusBadge';
import { getEtlStatus, getVerificationStatus } from '../../services/utils/metadata-helpers';

export interface DocumentListItemProps {
    document: Document;
    actions: React.ReactNode[];
}

const DocumentListItem = forwardRef<HTMLDivElement, DocumentListItemProps>(
    ({ document, actions }, ref) => {

        const handleNavigation = async (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            await router.navigate(`/documents/${document.id}`);
        };

        return (
            <div ref={ref}>
                <List.Item
                    actions={actions}
                    className="border-b rounded-md last:border-b-0 flex items-center"
                >
                    <List.Item.Meta
                        title={
                            <Space align="center" className="w-full">
                                <a
                                    href={`#/documents/${document.id}`}
                                    onClick={handleNavigation}
                                    className="text-xl truncate inline-block max-w-[400px]"
                                >
                                    {document.title}
                                </a>
                                <StatusBadge type="etl" status={getEtlStatus(document)} />
                                <StatusBadge type="verification" status={getVerificationStatus(document)} />
                            </Space>
                        }
                        description={
                            document.createdAt ? (
                                <div className="truncate max-w-full">
                                    {`Создан: ${moment(document.createdAt).format(
                                        'DD.MM.YYYY HH:mm'
                                    )}, Обновлен: ${moment(document.updatedAt).format('DD.MM.YYYY HH:mm')}`}
                                </div>
                            ) : (
                                <Spin size="small" />
                            )
                        }
                    />
                </List.Item>
            </div>
        );
    }
);

export default DocumentListItem;
